import { connect } from 'react-redux';
import { useFlags } from 'wsm-common-data';
import { getUrlParams } from '../utilities/url-params';
import { InvData } from '../data';

const isBrowser = (function isBrowser() {
	return typeof window !== 'undefined';
})();

const WidgetContainer = () => {
	const flags = useFlags();
	if (isBrowser && !window.DDC.InvData) {
		window.DDC.InvData = new InvData(flags);
		window.onpopstate = e => {
			if (e.state) {
				window.DDC.InvData.replaceSelections(
					e.state.urlParams,
					e.state.sortBy ? e.state.sortBy : '',
					e.state.start ? e.state.start : 0,
					false /* updateBrowserHistory */
				);
			} else {
				window.DDC.InvData.replaceSelections(
					getUrlParams(window.location.href),
					'',
					0,
					false
				);
			}
		};
	}
	return null;
};

WidgetContainer.propTypes = {};

const mapStateToProps = _state => {
	return {};
};

const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
